import { render, staticRenderFns } from "./LegacyReportBanner.vue?vue&type=template&id=67653808&scoped=true"
import script from "./LegacyReportBanner.vue?vue&type=script&lang=js"
export * from "./LegacyReportBanner.vue?vue&type=script&lang=js"
import style0 from "./LegacyReportBanner.vue?vue&type=style&index=0&id=67653808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67653808",
  null
  
)

export default component.exports